import { Injectable } from '@angular/core';
import { EformAPI } from '../e-form.api';
import { IdexService } from '../../idex.service';
import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { Router } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class IdleStateService {
   enable = false;
   constructor(private idle: Idle, private keepalive: Keepalive, private api: EformAPI,
               private service: IdexService, private router: Router, private dialog: MatDialog) { }

   active() {
      if (!this.enable) {
         this.enable = true;
         this.openSubscribe();
      } else {
         this.idle.watch();
         this.keepalive.start();
      }
   }

   deActive() {
      this.idle.stop();
      this.keepalive.stop();
   }

   openSubscribe() {
      this.api.getTimeout().subscribe(res => {
         this.idle.setIdle(res - 60);
      });

      this.idle.setTimeout(60);
      this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

      this.idle.onTimeout.subscribe(() => {
         this.service.logout();
         this.dialog.closeAll();
         this.router.navigate(['/login']);
      });

      this.keepalive.interval(600);

      this.keepalive.onPing.subscribe(() => {
         this.api.heartBeat().subscribe(() => {
            this.service.getCheckTimeOut().subscribe(() => {});
         });
      });

      this.idle.watch();
   }
}
